<script setup lang="ts">
import type { Event } from "./shared";

defineProps<{
    event: Event;
}>();
</script>

<template>
    <a
        class="w-full bg-misty-pine-1/40 p-3"
        :href="event.product.url"
    >
        <div class="aspect-[4/3] overflow-hidden bg-graphite-1 mb-3">
            <img
                v-if="event.product.main_image"
                :src="event.product.main_image"
                :alt="event.product.name"
                class="w-full h-full object-cover"
            />
        </div>

        <p
            class="font-bold text-10 mb-1 leading-145 -tracking-tightest2 text-darkGreen"
        >
            {{ event.event_details.time }}
        </p>

        <p
            class="font-medium text-16 !font-sans mb-2.5 -tracking-0.5 text-graphite-9 line-clamp-2"
            :title="event.event_details.name"
        >
            {{ event.event_details.name }}
        </p>

        <div class="flex flex-wrap gap-1">
            <span
                v-if="event.product.recommended_level"
                class="py-1.5 px-3 rounded-2xl bg-misty-pine-1 text-12 font-normal text-darkGreen"
            >
                {{ event.product.recommended_level }}
            </span>
            <span
                class="py-1.5 px-3 rounded-2xl bg-misty-pine-1 text-12 font-normal text-darkGreen"
            >
                {{ event.event_details.location ? "On Site" : "Online" }}
            </span>
        </div>
    </a>
</template>
